export default __webpack_public_path__ + "static/media/sticker-S.2c4f3551.png";